<template>
  <button id="NUMBER_1" name="1" class="btn num-btn" data-vcode="NUMBER_1">
    <div class="digit">1</div>
    <div class="letters" aria-hidden="true">&nbsp;</div>
  </button>
</template>
<script>
export default {};
</script>
